var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bind-channel" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title:
              "添加绑定商品" +
              (_vm.pram.name ? "【" + _vm.pram.name + "】" : ""),
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-alert",
            {
              staticStyle: { "margin-bottom": "20px" },
              attrs: { closable: false, type: "warning" },
            },
            [
              _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                _c("div", [
                  _c("span", { staticClass: "tip-dot" }),
                  _vm._v(" 指定分类，绑定商品为指定分类下的所有商品。"),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("span", { staticClass: "tip-dot" }),
                  _vm._v(" 指定标签，绑定商品为指定标签下的所有商品。"),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("span", { staticClass: "tip-dot" }),
                  _vm._v(" 指定SKU，绑定商品为上传文件中的所有商品。"),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            { ref: "pram", attrs: { "label-width": "100px", model: _vm.pram } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "商品来源：",
                    prop: "sourceType",
                    rules: [
                      {
                        required: true,
                        message: "请选择",
                        trigger: ["change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: {
                        disabled: Boolean(_vm.initSourceType),
                        size: "small",
                      },
                      on: { change: _vm.changeSourceType },
                      model: {
                        value: _vm.pram.sourceType,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "sourceType", $$v)
                        },
                        expression: "pram.sourceType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("自营商品"),
                      ]),
                      _vm._v(" "),
                      !_vm.miniProgramCustomer
                        ? _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("福司令商品"),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "绑定方式：",
                    prop: "type",
                    rules: [
                      {
                        required: true,
                        message: "请选择",
                        trigger: ["change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: Boolean(_vm.initType), size: "small" },
                      model: {
                        value: _vm.pram.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "type", $$v)
                        },
                        expression: "pram.type",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v("指定分类"),
                      ]),
                      _vm._v(" "),
                      _vm.pram.sourceType != 2
                        ? _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("指定标签"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 3 } }, [
                        _vm._v("指定SKU"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.pram.type
                ? _c(
                    "el-form-item",
                    { attrs: { label: "绑定内容：" } },
                    [
                      _vm.pram.type == 1
                        ? _c("el-cascader", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              options:
                                _vm.pram.sourceType == 2
                                  ? _vm.jdCateIdsOption
                                  : _vm.cateIdsOption,
                              props: {
                                children:
                                  _vm.pram.sourceType == 2
                                    ? "categoryList"
                                    : "child",
                                label: "name",
                                value: "id",
                                multiple: true,
                                leaf: 3,
                              },
                              clearable: "",
                            },
                            model: {
                              value: _vm.pram.cateIds,
                              callback: function ($$v) {
                                _vm.$set(_vm.pram, "cateIds", $$v)
                              },
                              expression: "pram.cateIds",
                            },
                          })
                        : _vm.pram.type == 2 && _vm.pram.sourceType != 2
                        ? _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                multiple: "",
                                clearable: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.pram.tagIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.pram, "tagIds", $$v)
                                },
                                expression: "pram.tagIds",
                              },
                            },
                            _vm._l(_vm.brandOption, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.labelName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          )
                        : _vm.pram.type == 3
                        ? _c(
                            "div",
                            [
                              _c("UploadFile", {
                                attrs: { accept: ".xlsx, .xls" },
                                model: {
                                  value: _vm.pram.url,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.pram, "url", $$v)
                                  },
                                  expression: "pram.url",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "tips" }, [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.pram.sourceType == 2
                                        ? "excel的第一行（字段行）必须存在有SKU ID"
                                        : "excel的第一行（字段行）必须存在有产品ID，SKU ID，SKU编码"
                                    ) +
                                    "\n          "
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.handerSubmit("pram")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }